module.exports = __webpack_public_path__ + "img/shoplogo.931350fc.svg";